import type { ReactElement } from "react";
import {
	createRootRoute,
	Link,
	Outlet,
	useRouterState,
} from "@tanstack/react-router";
import { signOut, useSession } from "@baseline/web/auth";

export const Route = createRootRoute({
	component: RootLayout,
});

function RootLayout(): ReactElement {
	const { data: session, isPending } = useSession();
	const pathname = useRouterState({ select: (s) => s.location.pathname });
	const isAuthPage = pathname === "/login" || pathname === "/signup";

	if (isAuthPage) {
		return <Outlet />;
	}

	// Redirect unauthenticated users to login
	if (!isPending && !session?.user && !isAuthPage) {
		window.location.href = "/login";
		return <div />;
	}

	return (
		<div className="bg-surface text-fg flex min-h-screen flex-col font-sans antialiased">
			<nav className="border-line bg-nav-backdrop fixed top-0 z-50 w-full border-b backdrop-blur-xl">
				<div className="mx-auto flex h-14 max-w-[960px] items-center justify-between px-6">
					<Link
						to="/"
						search={{ tab: "emails" }}
						className="text-xl font-semibold tracking-tight"
					>
						ingest
					</Link>
					<div className="flex items-center gap-6">
						{!isPending && session?.user && (
							<>
								<span className="text-fg-faint text-sm">
									{session.user.email}
								</span>
								<button
									type="button"
									onClick={() => signOut()}
									data-testid="sign-out-btn"
									className="text-fg-muted hover:text-accent text-[11px] font-light tracking-[0.2em] uppercase transition-colors"
								>
									Sign out
								</button>
							</>
						)}
					</div>
				</div>
			</nav>
			<main className="flex-1 pt-14">
				<Outlet />
			</main>
		</div>
	);
}
